import * as actionTypes from '../actions';

const initialState = {
    windowSize: 'sm',
    isLoading: false,
    sessionExpired: false,
    DatumOrder: [],
    creatSubAsset: '',
    DatumASSETS: [],
    datumASSETSCount: 0,
    DatumNext: true,
    deleteSubAsset: '',
    updateSubAsset: '',
    profileDetails: '',
    subAssetToBeEdited: [],
    DatumOrderCount: 0,
    DatumOrderNext: null,
    isSensorLoading: false,
    sensorData: [],
    get_telimatics: [],
    is_telimatics: false,
    datumOrderStatus: '',
    rcDetails: '',
    noDataFound: false,
    OpenDetails: false,
    datumData: [],
    isDatum: false,
    isDashboard: false,
    Elocks: [],
    ElockCount: 0,
    ElockNext: null,
    datum_decision: false,
    isError: false,
    refreshCounter: 0,
    DatumASSETList: [],
    DatumFAssets: [],
    DatumFAssetsCount: 0,
    DatumFAssetsNext: null,
    fuelLevelLoading: false,
    fuelLevelData: [],
    fuelLevelError: null,
    preDatums: [],
    preDatumsCount: 0,
    preDatumsNext: null,
    isPreDatumsLoading: false,
    DatumOrders: [],
    DatumOrdersCount: 0,
    DatumOrdersNext: null,
    OrderStatusCount: {},
    reconciliationDip: {},
};

function getUnique(array, key) {
    if (typeof key !== 'function') {
        const property = key;
        key = function (item) {
            return item[property];
        };
    }
    return Array.from(array.reduce(function (map, item) {
        const k = key(item);
        if (!map.has(k)) map.set(k, item);
        return map;
    }, new Map()).values());
}

const datumReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RECONCILIATION_DIP_LOADING:
        case actionTypes.RECONCILIATION_DIP_SUCCESS:
        case actionTypes.RECONCILIATION_DIP_FAILURE:
        case actionTypes.RECONCILIATION_DIP_CANCELED: {
            const {key, mode, requestId, offset} = action.meta;
            const previous = state.reconciliationDip?.[key];
            const loading = action.type === actionTypes.RECONCILIATION_DIP_LOADING;
            if (!loading && previous?.requestId !== requestId) return state;
            let data = previous?.data || null;
            if (action.type === actionTypes.RECONCILIATION_DIP_SUCCESS) {
                data = action.payload;
                if (offset > 0 && data?.results) {
                    data = {...data, results: getUnique([...(previous?.data?.results || []), ...data.results],
                        mode === "dates" ? "date" : mode === "months" ? (item) => item.year + "-" + item.month : "id")};
                }
            }
            return {...state, reconciliationDip: {...state.reconciliationDip,
                [key]: {mode, requestId, loading, data,
                    error: action.type === actionTypes.RECONCILIATION_DIP_FAILURE ? action.payload : null}}};
        }
        case actionTypes.DATUM_LOADING: {
            return {
                ...state,
                isLoading: true,
                sessionExpired: false,
                datum_decision: false

            };
        }
        case actionTypes.DATUM_DECISION: {
                return {
                    ...state,
                    datum_decision: action.payload,
                    sessionExpired: false,
                };
        }
        case actionTypes.DATUM_LOADING_FALSE: {
            return {
                ...state,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.DATUM_ORDERS: {
            return {
                ...state,
                datum_decision: false,
                DatumOrder: getUnique(state?.DatumOrder?.concat(action.payload?.results), "id"),
                DatumOrderCount: action.payload?.count,
                DatumOrderNext: action.payload?.next,
                isLoading: false,
                sessionExpired: false,
                isError: false

            };
        }

        case actionTypes.SET_DATA: {
            return {
                ...state,
                datumData: action?.payload?.datumData,
                isDatum: action?.payload?.isDatum,
                OpenDetails: action?.payload?.OpenDetails,
                assetType: action?.payload?.assetType,
                isDashboard: action?.payload?.isDashboard,
                assetId: action?.payload?.assetId
            }
        }
        case actionTypes.DATUM_ORDER_ACCEPT: {
            return {
                ...state,
                DatumOrder: state.DatumOrder.filter(order => order.id !== action.payload),
                sessionExpired: false,
            }
        }
        case actionTypes.SOMETHING_WRONG: {
            return {
                ...state,
                isError: true,
                isLoading: false,
                sessionExpired: false,
            }
        }
        case actionTypes.DATUM_ASSET_LIST: {
            return {
                ...state,
                DatumASSETS: state.DatumASSETS.concat(action.payload?.results),
                datumASSETSCount: action.payload?.count,
                DatumNext: action.payload?.next,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.All_ASSET_LIST: {
            return {
                ...state,
                DatumASSETList: state.DatumASSETList.concat(action.payload?.results),
                datumASSETSCount: action.payload?.count,
                DatumNext: action.payload?.next,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.DATUM_ASSET_CREATE: {
            return {
                ...state,
                creatSubAsset: action.payload,
                DatumASSETS: [],
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.DATUM_ASSET_DELETE: {
            return {
                ...state,
                deleteSubAsset: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.DATUM_ASSET_UPDATE: {
            return {
                ...state,
                updateSubAsset: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.DATUM_ORDER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                profileDetails: action?.payload,
            };
        }
        case actionTypes.DATUM_ORDER_UPDATE: {
            return {
                ...state,
                isLoading: false,

            }
        }
        case actionTypes.DATUM_F_SUB_ORDER_UPDATE: {
            return {
                ...state,
                isLoading: false,

            }
        }
        case actionTypes.SHELL_DATA: {
            return {
                ...state,
                isShellLoading: false,
                SHELL_DATA: action?.payload,
            };
        }
        case actionTypes.SHELL_LOADING: {
            return {
                ...state,
                isShellLoading: true,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_SINGLE_SUB_ASSET: {
            return {
                ...state,
                isShellLoading: false,
                subAssetToBeEdited: action?.payload,
                sessionExpired: false,
                assetModified: false,
            };
        }
        case actionTypes.SENSOR_DATA: {
            return {
                ...state,
                isSensorLoading: false,
                sensorData: action?.payload?.results,
                sessionExpired: false,
            };
        }
        case actionTypes.SENSOR_DATA_LOADING: {
            return {
                ...state,
                isSensorLoading: true,
            };
        }
        case actionTypes.CLEAR_SUB_ASSET: {
            return {
                ...state,
                subAssetToBeEdited: [],
                DatumOrder: [],
                DatumASSETS: [],
                datumASSETSCount: 0,
                DatumFAssets: [],
                DatumFAssetsCount: 0,
            }
        }
        case actionTypes.GET_TELEMATICS_TYPE: {
            return {
                ...state,
                is_telimatics: true,
                get_telimatics: action?.payload,
            }
        }
        case actionTypes.DATUM_ORDER_STATUS: {
            return {
                ...state,
                datumOrderStatus: action.payload
            }
        }
        case  actionTypes.DATUM_ORDER_STATUS_NULL: {
            return {
                ...state,
                datumOrderStatus: ''
            }
        }
        case actionTypes.GET_RC_DETAILS: {
            return {
                ...state,
                isLoading: false,
                rcDetails: action.payload,
            }
        }
        case actionTypes.GET_RC_DETAILS_NOT_FOUND: {
            return {
                ...state,
                rcDetails: action.payload,
                noDataFound: true,
                isLoading: false
            }
        }
        case actionTypes.GET_RC_DETAILS_FAIL: {
            return {
                ...state,
                rcDetails: action.payload,
                isLoading: false
            }
        }
        case actionTypes.GET_DATUM_ENQUIRY_FAIL: {
            return {
                ...state,
                isLoading: false
            }
        }
        case actionTypes.GET_DATUM_ENQUIRY: {
            return {
                ...state,
                isLoading: false
            }
        }
        case actionTypes.ELOCK_LOADING: {
            return {
                ...state,
                isLoading: true,
                sessionExpired: false,

            };
        }
        case actionTypes.ALL_ELOCK: {
            return {
                ...state,
                Elocks: getUnique(state?.Elocks?.concat(action.payload?.results), "id"),
                ElockCount: action.payload?.count,
                ElockNext: action.payload?.next,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.ELOCK_ACCEPT: {
            return {
                ...state,
                Elocks: []
            }
        }
        case actionTypes.GET_ASSETS_FAIL: {
            return {
                ...state,
                isLoading: false,
                sessionExpired: false,
                error: true,
            };
        }
        case actionTypes.GET_ASSET_LIST: {

            return {
                ...state,
                isAssetListLoading: false,
                sessionExpired: false,
                assetList: action?.payload,
                assetIds: action?.payload?.map((item) => item?.id)
            }

        }
        case actionTypes.REFRESH_DATUM_ORDERS: {
            return {
                ...state,
                refreshCounter: state.refreshCounter + 1
            }
        }
        case actionTypes.DATUM_F_ASSET_LIST: {
            const newAssets = action.payload?.results || action.payload?.data || [];
            return {
                ...state,
                DatumFAssets: state.DatumFAssets.concat(newAssets),
                DatumFAssetsCount: action.payload?.count,
                DatumFAssetsNext: action.payload?.next,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_FUEL_LEVEL_Percent:
            return {
                ...state,
                fuelLevelLoading: true,
                fuelLevelError: null,
            };
        case actionTypes.GET_FUEL_LEVEL_SUCCESS:
            return {
                ...state,
                fuelLevelLoading: false,
                fuelLevelData: action.payload,
                fuelLevelError: null,
            };
        case actionTypes.GET_FUEL_LEVEL_FAILURE:
            return {
                ...state,
                fuelLevelLoading: false,
                fuelLevelData: null,
                fuelLevelError: action.payload,
            };
        case actionTypes.PRE_DATUMS_LOADING:
            return {
                ...state,
                isPreDatumsLoading: true,
                isError: false,
                sessionExpired: false
            };
        case actionTypes.GET_PRE_DATUMS: {
            const responseData = action.payload?.data || action.payload || {};
            const results = responseData?.results || [];
            
            return {
                ...state,
                preDatums: action.fetchMoreData ? [...state.preDatums, ...results] : results,
                preDatumsCount: responseData?.count || 0,
                preDatumsNext: responseData?.next || null,
                isPreDatumsLoading: false,
                isError: false,
                sessionExpired: false
            };
        }
        case actionTypes.GET_PRE_DATUMS_FAIL:
            return {
                ...state,
                isPreDatumsLoading: false,
                isError: true,
                sessionExpired: action.payload?.status === 401
            };
        case actionTypes.SET_DATUM_DRAFT:
            return {
                ...state,
                ...action.payload
            };
        case actionTypes.CLEAR_DATUM_DRAFT:
            return {
                ...state,
                datumStages: {
                    asset_id: null,
                    name: ""
                }
            };
        case actionTypes.GET_ALL_DATUM_ORDERS: {
            const responseData = action.payload?.data || action.payload || {};
            const results = responseData?.results || [];
            return {
                ...state,
                DatumOrders: action.fetchMoreData
                    ? getUnique([...state.DatumOrders, ...results], "id")
                    : results,
                DatumOrdersCount: responseData.count || 0,
                DatumOrdersNext: responseData.next || null,
                isLoading: false,
                isError: false,
            };
        }
        case actionTypes.ALL_DATUM_ORDERS_LOADING:
            return { ...state, isLoading: true };
        case actionTypes.GET_ALL_DATUM_ORDERS_FAIL:
            return { ...state, isLoading: false, isError: true };
        case actionTypes.GET_ORDER_STATUS_COUNT: {
            const responseData = action.payload?.data || action.payload || {};
            
            return {
                ...state,
                OrderStatusCount: responseData,
                isLoading: false,
                isError: false,
                sessionExpired: false
            };
        }
        case actionTypes.ORDER_STATUS_COUNT_LOADING:
            return { ...state, isLoading: true };
        case actionTypes.GET_ORDER_STATUS_COUNT_FAIL:
            return { ...state, isLoading: false, isError: true };
        default: {
            return {
                ...state,
            };
        }
    }
};


export default datumReducer;